import { useState, useCallback, createContext, useMemo } from 'react';
import { listToMap, compareNumber } from '@togglecorp/fujs';

function useOrderState(keys) {
  const [ordering, setOrdering] = useState(keys);
  const moveOrderingItem = useCallback((drag, drop) => {
    setOrdering(oldOrdering => {
      const dragPosition = oldOrdering.findIndex(o => o.name === drag);
      const dropPosition = oldOrdering.findIndex(o => o.name === drop);

      if (dragPosition === dropPosition) {
        return oldOrdering;
      }

      if (dragPosition === -1 || dropPosition === -1) {
        console.error('Drag or drop item could not be found');
        return oldOrdering;
      }

      const dragItem = oldOrdering[dragPosition];
      const newOrdering = [...oldOrdering];

      if (dragPosition > dropPosition) {
        newOrdering.splice(dragPosition, 1);
        newOrdering.splice(dropPosition, 0, dragItem);
      } else {
        newOrdering.splice(dropPosition + 1, 0, dragItem);
        newOrdering.splice(dragPosition, 1);
      }

      return newOrdering;
    });
  }, []);
  return {
    ordering,
    moveOrderingItem,
    setOrdering
  };
}
const initialValue = {
  ordering: [],
  setOrdering: state => {
    console.warn('Trying to set to ', state);
  },
  moveOrderingItem: (drag, drop) => {
    console.warn(`Trying to drag item ${drag} to item ${drop}`);
  }
};
const OrderContext = /*#__PURE__*/createContext(initialValue);

function useOrdering(columns, ordering) {
  const filteredData = useMemo(() => {
    const mapping = listToMap(ordering, item => item.name, (item, __, index) => ({ ...item,
      order: index
    }));
    const sortedColumns = columns.filter(foo => !!mapping[foo.id]).sort((foo, bar) => {
      var _mapping$foo$id, _mapping$bar$id;

      // FIXME: this can be optimized
      const fooOrder = (_mapping$foo$id = mapping[foo.id]) === null || _mapping$foo$id === void 0 ? void 0 : _mapping$foo$id.order;
      const barOrder = (_mapping$bar$id = mapping[bar.id]) === null || _mapping$bar$id === void 0 ? void 0 : _mapping$bar$id.order;
      return compareNumber(fooOrder, barOrder);
    });
    return sortedColumns;
  }, [ordering, columns]);
  return filteredData;
}

export { OrderContext, useOrdering as default, useOrderState };
//# sourceMappingURL=useOrdering.js.map
